export default __webpack_public_path__ + "static/media/chevron.75db4b9a.svg";